module.exports = __webpack_public_path__ + "static/media/become_contractor_banner.b7d01522.svg";